// Moderated
export const VIDEO_CALL_TITLE = 'Interviews';
export const VIDEO_CALL_SUBTITLE = 'Schedule calls with participants.';
export const FOCUS_GROUPS_TITLE = 'Focus groups';
export const FOCUS_GROUPS_SUBTITLE = 'Schedule group calls with participants.';

export const ROUND_ROBIN_TITLE = 'Round robin interviews';
export const ROUND_ROBIN_SUBTITLE = 'Rotate moderators for each interview.';

export const COLLECTIVE_TITLE = 'Collective interviews';
export const COLLECTIVE_SUBTITLE = 'Group moderation for each interview.';

export const CONTINUOUS_TITLE = 'Continuous interviews';
export const CONTINUOUS_SUBTITLE = 'Schedule interviews every week.';

// Unmoderated
export const UNMODERATED_TITLE = 'Unmoderated test';
export const UNMODERATED_SUBTITLE = 'Gather insights asynchronously.';

export const PROTOTYPE_TEST_TITLE = 'Prototype test';
export const PROTOTYPE_TEST_SUBTITLE = 'Test a prototype asynchronously.';

export const CARD_SORT_TITLE = 'Card sort';
export const CARD_SORT_SUBTITLE = 'See how users organize information.';

export const TREE_TEST_TITLE = 'Tree test';
export const TREE_TEST_SUBTITLE = 'Test navigation paths with users.';

export const AI_MODERATION_TITLE = 'AI moderation interview';
export const AI_MODERATION_SUBTITLE = 'AI moderation interview.';

export const FIVE_SECOND_TEST_TITLE = '5 second test';
export const FIVE_SECOND_TEST_SUBTITLE = 'Test user recall of key content.';

export const FIRST_CLICK_TEST_TITLE = 'First click test';
export const FIRST_CLICK_TEST_SUBTITLE = 'See where users click first on the page.';

export const PREFERENCE_TEST_TITLE = 'Preference test';
export const PREFERENCE_TEST_SUBTITLE = 'Evaluate user preference of designs.';

// Other
export const SURVEY_TITLE = 'Survey';
export const SURVEY_SUBTITLE = 'Create and send out questions.';

export const PANEL_TITLE = 'Panel recruitment';
export const PANEL_SUBTITLE = 'Drive opt-ins to participate in future research.';

export const ONLINE_TASK_TITLE = 'Online task';
export const ONLINE_TASK_SUBTITLE = 'Launch a test from a different provider.';
